// src/components/common/AnimatedSection.js
import styled, { css, keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const getAnimation = (type) => {
  switch (type) {
    case 'fadeInUp':
      return fadeInUp;
    case 'fadeInLeft':
      return fadeInLeft;
    case 'fadeInRight':
      return fadeInRight;
    case 'fadeIn':
      return fadeIn;
    case 'scaleIn':
      return scaleIn;
    default:
      return fadeInUp;
  }
};

export const AnimatedSection = styled.div`
  opacity: 0;
  transform: ${props => {
    switch (props.animation) {
      case 'fadeInUp':
        return 'translateY(60px)';
      case 'fadeInLeft':
        return 'translateX(-60px)';
      case 'fadeInRight':
        return 'translateX(60px)';
      case 'scaleIn':
        return 'scale(0.9)';
      default:
        return 'translateY(60px)';
    }
  }};
  
  ${props => props.isVisible && css`
    animation: ${getAnimation(props.animation)} 0.8s ease-out forwards;
    animation-delay: ${props.delay || '0s'};
  `}
`;
